var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AccountPropertySection',_vm._b({attrs:{"placeholder":_vm.t('settings', 'Your organisation')}},'AccountPropertySection',_vm.organisation,false,true))
}
var staticRenderFns = []

export { render, staticRenderFns }